// extracted by mini-css-extract-plugin
export default {"selectedAvatar":"CustomAvatar_selectedAvatar__lTOsX","avatarImage":"CustomAvatar_avatarImage__FILQb"};